import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import PublishIcon from "@mui/icons-material/Publish";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import ConfirmDialog from "../../components/popups/ConfirmDialog";
import { prefillPlanning, getPlanning } from "./planningSlice";
import { checkPermission, isAdmin, showErrorToast } from "../../app/utils/helpers";
import { submitShifts } from "./planningSlice";
import { setPublishedStatus } from "./planningSlice";
import { setIsLoading } from "../common/commonSlice";
import { config } from "../../app/utils/config";

export function PublishModal(props) {

  const dispatch = useDispatch()
  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
  const selectedDate = useSelector((state) => state.planning.selectedDate)
  const myTeam = useSelector((state) => state.teams.myTeam)
  const userRoleId = useSelector((state) => state.login.userRoleId)
  const collabs = useSelector((state) => state.collabs.list)

  const [notifyCollabs, setNotifyCollabs] = useState(true)

  const handlePublish = (event) => {
    hide()
    dispatch(setIsLoading(true))

    dispatch(submitShifts({
      teamIds: selectedTeamsIds.filter(id => isManager(id)),
      date: selectedDate,
      notify: notifyCollabs
    })).then((response) => {
      dispatch(setIsLoading(false))
      if (response['payload']['responseData']) {
        loadPlanning()
      }
      if (response['payload']['responseError']) {
        showErrorToast()
      }
    })
  }

  function loadPlanning(){
    if (selectedTeamsIds && selectedTeamsIds.length && collabs.length) {
      let selectedCollabsIds = collabs.reduce((array, current) =>{
        array.push(current.id)
        return array
      }, [])
      dispatch(getPlanning({selectedTeamsIds, selectedCollabsIds}))
    }
  }

  function isManager(teamId) {
    return checkPermission(config.scopes.shifts, config.permissionTypes.edit, teamId)
    return isAdmin(userRoleId) && (!myTeam || myTeam.userRoleId == 2 || teamId != myTeam.id)
  }

  function hide() {
    props.onHide()
  }

  return (
    <ConfirmDialog
      open={!!props.show}
      icon={PublishIcon}
      title={<Langs str='PUBLISH' />}
      message={<Langs str='PUBLISH_CONFIRMATION' />}
      confirmLabel={<Langs str='PUBLISH' />}
      onConfirm={() => handlePublish()}
      onCancel={() => hide()}
    >
        <FormControlLabel
          sx={{ mt: 1.5 }}
          control={
            <Checkbox
              checked={notifyCollabs}
              onChange={(e) => setNotifyCollabs(e.target.checked)}
              sx={{ color: "#FF9015", "&.Mui-checked": { color: "#FF9015" } }}
            />
          }
          label={<Typography variant="body2"><Langs str="NOTIFY_COLLABS" /></Typography>}
        />
    </ConfirmDialog>
  )
}
